import {Component, ViewChild} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {DateTime, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TFieldType, TGoogleAnalytic, TStatusBar, Util} from '../../../app/util';
import {TAction, TCarsale, TConviteTipo, TFinanceSide, TImageModel, TImageSpace, TPaybookFato, TPaybookModo, TPaybookTipo} from "../../../app/enum";

import {ProfilePagePage} from "../profile-page/profile-page";

import {SpotdayService} from "../../../providers/spotday-service";
import {LogadoService} from "../../../providers/logado-service";
import {DataService} from "../../../providers/data-service";
import {EntrakiOpenPage} from '../entraki-open/entraki-open';
import {CarbookService} from '../../../providers/carbook-service';
import {PaybookCartPage} from '../paybook-cart/paybook-cart';
import {SpotdayViewPage} from '../spotday-view/spotday-view';
import {WebstorOpenPage} from '../webstor-open/webstor-open';
import {ModalFieldPage} from '../modal-field/modal-field';
import {VoucherInfoPage} from '../voucher-info/voucher-info';

@Component({
    selector: 'page-spotday-info',
    templateUrl: 'spotday-info.html',
    providers: [SpotdayService]
})
export class SpotdayInfoPage {

    TImageModel: any = TImageModel;
    TImageSpace: any = TImageSpace;

    config: any;
    logado: any;
    etapa: number;
    userset: any;

    rootspot: any;
    
    spotday: any;

    spotdayDati: string;

    @ViewChild(DateTime) iondate: DateTime;
    
    constructor(public navCtrl: NavController, 
                public navParams: NavParams, 
                public viewCtrl: ViewController,
                public sanitizer: DomSanitizer,
                public util: Util,
                public dataService: DataService,
                public spotdayService: SpotdayService,
                public carbookService: CarbookService,
                public logadoService: LogadoService) {

        this.config = CONFIG;

        this.logado = this.logadoService.getAuth();
        this.etapa = this.navParams.get('etapa');
        this.userset = this.navParams.get('userset');

        this.rootspot = this.navParams.get('rootspot');
        
        this.spotday = this.navParams.get('spotday');
        let spotdayID = this.util.anyParams(0, this.navParams.get('spotdayID'), this.dataService.get('param.spotdayid'));

        this.spotdayDati = (this.spotday ? this.spotday.SpotdayDate.split(' ')[0] : this.util.dateToStr());

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Spotday Info', '/spotday-info');

        if (this.etapa == 0 && !this.spotday) this.spotdayLoad(spotdayID);
        
    }

    ionViewDidEnter() {

        //this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    getTitle() {

        if (!this.spotday) return '';
        return this.spotday.Hotspot.Branded.BrandedNome;

    }

    spotdayLoad(spotdayID: number) {

        // SPOTDAY-NOVO
        if (spotdayID == 0) {
            let hotspot = this.rootspot.Hotspots[0];
            this.spotday = {SpotdayID: 0, SpotdayFile: '', SpotdayDate: null, SpotdayFlag: true, SpotdayRain: true, SpotdayNome: '', Projeto: null, Hotspot: hotspot};
            return
        }


        // SPOTDAY-LOAD
        let loading = this.util.loadingDots();
        loading.present();

        this.spotdayService.spotday(TAction.acLoad, spotdayID)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                this.spotday = (!data.Spotdays || !data.Spotdays[0] ? null : data.Spotdays[0]);
                this.spotdayDati = (this.spotday ? this.spotday.SpotdayDate.split(' ')[0] : this.util.dateToStr());

                let style = this.util.stylesBarColor(this.spotday.Hotspot.Branded.BrandedCora);
                this.util.statusBarColor(style);

            }, erro => {

                this.util.alertResult(erro, () => this.dismiss());

            });

    }

    spotdayLixo() {

        let onOkay = () => {

            let loading = this.util.loadingDots();
            loading.present();

            this.spotdayService.spotday(TAction.acLixo, this.spotday.SpotdayID, this.rootspot.Hotspots[0].HotspotID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => this.dismiss(),
                    erro => this.util.alertResult(erro)
                );

        }

        let alerta = 'Esse processo não tem volta.';
        this.util.alertQuestion('Deseja excluir o evento?', alerta, 'Continuar', () => onOkay(), false, true);
    
    }

    spotdaySave(that?) {

        let loading = this.util.loadingDots();
        loading.present();

        this.spotdayService.spotday(TAction.acSave, this.spotday.SpotdayID, this.rootspot.Hotspots[0].HotspotID, 0, this.spotday)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                this.spotday.SpotdayID = data.Codigo;
                if ( that) that.dismiss();
                if (!that) this.dismiss();

            }, erro => {

                this.util.alertResult(erro);

            });

    }

    spotdayMany() {

        if (!this.userset || !this.spotday.SpotdayFlag) return;

        let lixo = (this.spotday.SpotdayID && this.logado.Profile.ProfileTeam);

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Informações', handler: () => this.spotdayHtml()});
        if (lixo) buttons.push({text: 'Excluir', handler: () => this.spotdayLixo(), role: 'destructive'});
        this.util.sheetOpen(buttons, 'MENU');
        
    }

    spotdayLink() {

        //let params = '&spotdayid=' + this.spotday.SpotdayID + '&profileid=' + this.logado.Profile.ProfileID;
        //this.profileRepository.sharedyLink(TShareupTipo.shSpotday, this.meritums[0].MeritumNome, 'spotday', params);

    }

    profilePage(profile) {

        let object = {profileID: profile.ProfileID};
        this.navCtrl.push(ProfilePagePage, object);

    }

    divulgaUser() {

    }

    spotdayMini() {

        if (this.spotday.SpotdayDate) {
            return this.spotday.SpotdayDate.split(' ')[0];
        }

        let hojeday = this.util.dateHoje();
        let textday = this.util.dateToStr(hojeday).split(' ')[0];
        return textday;

    }

    spotdayMaxi() {

        let hojeday = this.util.dateHoje();
        let lastday = this.util.diaLast(hojeday, 4);
        let textday = this.util.dateToStr(lastday).split(' ')[0];
        return textday;

    }

    spotdayKita() {

        let object = {etapa: 0, spotday: this.spotday};
        this.util.modalopen(SpotdayViewPage, 'alto', false, object).subscribe();

    }

    voucherMenu() {

        let voucherID = this.spotday.VoucherID;
        let profileID = this.logado.Profile.ProfileID;

        let onDone = (data) => {
            if (data) this.spotday.VoucherID = data.Codigo;
        }
        
        let object = {etapa: 1, voucherID: voucherID, profileID: profileID, hotspotID: 0, notifyeID: 0};
        this.util.modalopen(VoucherInfoPage, 'alto', false, object).subscribe(data => onDone(data));

    }

    voucherOpen() {

        if ( this.spotday.VoucherID) this.voucherMenu();
        if (!this.spotday.VoucherID) this.entrakiOpen();

        // let titulo = 'Você já tem voucher para esse evento';
        // let alerta = 'Deseja selecionar um amigo?';
        // this.util.alertObserv(titulo, alerta, 'Sim', false, TModalAlert.maWhite).subscribe(
        //     () => alert('Informe o CPF ou Selecione o Amigo'),
        //     () => this.dismiss());

    }

    /** ************************************************* EVENTO ************************************************** **/
    /** ************************************************* etapa-0 ************************************************* **/

    projetoMenu() {

        if (!this.userset || !this.spotday.SpotdayFlag) return;

        let onSave = (array) => {
            this.spotday.Projeto = array[0];
            if (this.spotday.SpotdayID) this.spotdaySave();
        };

        let objectPrj = {homeb: false, etapa: 0, title: null, keyname: 'Projeto', toggler: 'hide', rootspot: this.rootspot};
        this.util.modalopen(WebstorOpenPage, 'alto', false, objectPrj).subscribe(data => onSave(data));

    }

    spotdayFixe() {

        let hora = 0;
        let minu = 0;

        let horas = '';
        if (this.spotday.SpotdayDate) horas = this.spotday.SpotdayDate.slice(11, 16);
        if (horas) {
            hora = parseInt(horas.slice(0, 2));
            minu = parseInt(horas.slice(3, 5));
        }

        let onSave = (hora, minu) => {
            hora = (hora <= 9 ? '0' + hora : ''+ hora);
            minu = (minu <= 9 ? '0' + minu : ''+ minu);

            this.spotday.SpotdayDate = this.spotdayDati + ' ' + hora + ':' + minu + ':00';
            if (this.spotday.SpotdayID) this.spotdaySave();
        };

        let array = [0, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];

        let buttons: Array<any> = [];
        buttons.push({text: '0 hrs', value: 0});
        for (let i = 23; i >= 1; i--) buttons.push({text: i + ' hrs', value: i});

        let buttens: Array<any> = [];
        buttens.push({text: '00 min', value: 0});
        buttens.push({text: '30 min', value: 30});
        buttens.push({text: '59 min', value: 59});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns.push({name: 'ruut', options: buttens});
        columns[0].selectedIndex = array.indexOf(hora);
        columns[1].selectedIndex = (minu == 30) ? 1 : 0;
        this.util.pickerOpen(columns, onSave);

    }

    spotdayData() {

        if (!this.userset || !this.spotday.SpotdayFlag) return;
        this.iondate.open();

    }

    spotdayFile() {

        if (!this.userset || !this.spotday.SpotdayFlag) return;

        let mimestp = 'image/jpeg';
        let filebyte = (200 * 1024);
        let options = {acceptTypes: mimestp, sizebyte: filebyte, selectLimit: 1, minmax: 'FIX', width: 500, height: 750, quality: 100};

        this.util.fileSelect(options).subscribe(
            base => {

                base.forEach((item, index) => {

                    this.spotday.SpotdayHash = item.hash;
                    this.spotday.SpotdayFile = item.base64;
                    this.spotday.SpotdayFile64 = item.base64.split(',')[1];

                });

                if (this.spotday.SpotdayID) this.spotdaySave();

            },
            erro => this.util.alertResult(erro)
        );

    }

    spotdayRain() {

        if (this.spotday.SpotdayID) this.spotdaySave();

    }

    spotdayHtml() {

        let onOkiy = (that, okiy, index, isLast) => {

            if (this.util.slideNext(that, !isLast)) return;

            this.spotday.SpotdayHtml = okiy[0].groups[0].fields[0].value;
            if (this.spotday.SpotdayID) {
                this.spotdaySave(that);
                return;
            }

            that.dismiss();

        };

        /** SLIDE 01 **/
        let fieldFast = this.config.modalField(TFieldType.ftHtml, null, null, null, this.spotday.SpotdayHtml, null, null);
        let groupFast = this.config.modalGroup(null, [fieldFast]);
        let slideFast = this.config.modalSlide('Mensagem', null, null, null, 'CorDash', [groupFast]);

        let slides = [slideFast];

        this.util.modalopen(ModalFieldPage, 'quad', false, {slides: slides, onOkiy: onOkiy}).subscribe();

    }

    carbookOpen(spotdayID, hotspot, ambientSeta) {

        /** CARRINHO SET|OPEN **/
        this.carbookService.setStart(TCarsale.csTicket, hotspot);



        let paycria = {
            HotspotID: hotspot.HotspotID,
            ContratID: 0,
            Branded: hotspot.Branded,
            Promote: null,
            Projeto: {ProjetoID: 1000, ProjetoNome: 'Fake'},
            Profile: this.util.deepCopy(this.logado.Profile),

            PaybookID: 0,
            PaybookSide: TFinanceSide.cdCredito,
            PaybookFato: TPaybookFato.ctVencer,
            PaybookTipo: TPaybookTipo.pbCard,
            PaybookModo: TPaybookModo.pmUser,
            PaybookNoro: 0,
            PaybookHide: false,
            PaybookParc: 0,
            PaybookBase: this.util.dateToStr(null, false),
            PaybookCria: this.util.dateToStr(null, true),
            PaybookBora: '',
            PaybookText: '',

            Consumos: [],
            Parcelas: [],
            Invoices: [],
        };
        this.carbookService.paybookPush(paycria);


        let conviteCash = ambientSeta.Convite.ConviteSeco+ambientSeta.Convite.ConviteSuma;

        let consume = {Profile: null, Branded: null, Blended: null, Produto: null, Consumo: null};
        consume.Profile = this.util.deepCopy(this.logado.Profile);
        consume.Branded = {};
        consume.Blended = {};
        consume.Produto = {ProdutoID: 1000000000, ProdutoNome: 'Convite'};
        consume.Consumo = {ConsumoQtde: 1, ConsumoCash: conviteCash, ConsumoLess: 0, AmbientSeta: ambientSeta};


        let onThen = () => {
            if (!this.viewCtrl.isOverlay) this.util.navActive(this.navCtrl).getPrevious().dismiss();
            if ( this.viewCtrl.isOverlay) this.dismiss();
        }

        let object = {etapa: 1, spotdayID: spotdayID, consumo: consume};
        this.util.modalopen(PaybookCartPage, 'alto', false, object, null, null, null, onThen).subscribe();

    }

    entrakiOpen() {

        let hotspot = this.spotday.Hotspot;
        let object = {etapa: 1, hotspot: hotspot, userset: null, profileDesk: this.logado.Profile, spotdayID: this.spotday.SpotdayID, paybookTipo: TPaybookTipo.pbCard, paybookModo: TPaybookModo.pmUser, conviteTipo: TConviteTipo.ctConviteLista};
        this.util.modalopen(EntrakiOpenPage, 'quad', true, object)
            .subscribe(done => {

                //Voucher Lista
                if (done.Codigo) {
                    this.spotday.VoucherID = done.Codigo;
                    return;
                }

                //Voucher Purchase
                if (done.Convite.ConviteSale) {
                    this.carbookOpen(this.spotday.SpotdayID, hotspot, done);
                    return;
                }

            });

    }


    dismiss() {

        if (!this.viewCtrl.isOverlay) this.navCtrl.pop();
        if ( this.viewCtrl.isOverlay) this.viewCtrl.dismiss();

        this.util.statusBarColor(TStatusBar.sbBackupRestore);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/spotday-info/spotday-info.ts